import { useEffect, useState } from 'react';
import { STR_UNIVERSITY_IDS } from 'src/common/accountIds';
import { getUniversityIdNew } from 'src/helpers/Helpers';
var supportedLanguageValues = [
    'az',
    'ar',
    'bn',
    'bg',
    'zh',
    'zh-Hant',
    'hr',
    'cs',
    'nl',
    'et',
    'fi',
    'fo',
    'fr',
    'ka',
    'de',
    'el',
    'haw',
    'he',
    'hi',
    'hu',
    'it',
    'id',
    'ja',
    'ko',
    'lt',
    'lv',
    'mgo',
    'no',
    'fa',
    'pl',
    'pt-BR',
    'pt',
    'pa',
    'ro',
    'ru',
    'sk',
    'sl',
    'sr',
    'sr-Latn',
    'es',
    'es-MX',
    'sv',
    'tr',
    'th',
    'tl',
    'uk',
    'cy',
    'ceb',
    'sm',
    'vi',
    'da',
    'ca',
    'ht',
    'ilo',
    'ps',
    'prs',
    'eu',
    'hmn',
    'hy',
];
export var useUserWayLanguage = function (fallbackLanguage, timeout) {
    if (timeout === void 0) { timeout = 1500; }
    var _a = useState(), language = _a[0], setLanguage = _a[1];
    var _b = useState(false), ready = _b[0], setReady = _b[1];
    var universityId = getUniversityIdNew();
    useEffect(function () {
        localStorage.removeItem('userway-selectedLang');
        localStorage.removeItem('userway-selectedSiteLang');
        var handleParentMessage = function (event) {
            var _a;
            if (((_a = event.data) === null || _a === void 0 ? void 0 : _a.name) === 'languageDetectEvent') {
                var receivedLang = event.data.language;
                if (supportedLanguageValues.includes(receivedLang)) {
                    // eslint-disable-next-line no-console
                    console.log("Detected supported language: ".concat(receivedLang));
                    setLanguage(event.data.language);
                }
                setReady(true);
                cleanup();
            }
        };
        var cleanup = function () {
            clearTimeout(timeoutId);
            window.removeEventListener('message', handleParentMessage);
        };
        window.parent.postMessage('widgetReadyForLanguage', '*');
        window.addEventListener('message', handleParentMessage);
        var timeoutId = setTimeout(function () {
            if (fallbackLanguage) {
                setLanguage(fallbackLanguage);
            }
            setReady(true);
            cleanup();
        }, timeout);
        return cleanup;
    }, [fallbackLanguage, timeout]);
    // Exclude University of Nicosia and Test University 2 from language detection
    if (universityId === STR_UNIVERSITY_IDS.UNIVERSITY_OF_NICOSIA || universityId === STR_UNIVERSITY_IDS.TEST_UNI_2) {
        return {
            ready: true,
        };
    }
    return {
        language: language,
        ready: ready,
    };
};
